








































































































import Vue from 'vue'
import moment from 'moment'
import ReportForm from '@/components/ReportForm.vue'
import api, { ApiResponse } from '../../../../api'
import zones from '../../../../api/zones.json'
import { fetchReportList, deleteReport, getReportDownloadUrl } from '../../../../api/report-api'

export default Vue.extend({
  components: {
    ReportForm
  },

  data() {
    return {
      activeTab: 'history',
      tabs: [
        { key: 'history', text: 'Historique' },
        { key: 'disbursements', text: 'Décaissements' },
        { key: 'refunds', text: 'Remboursements' },
        { key: 'global', text: 'Globaux' }
      ],
      exportFormat: 'xlsx',
      reportLoaders: {
        disbursements: {},
        refunds: {},
        global: {}
      },
      showSuccessAlert: false,
      historyItems: [] as any[],
      historyTotal: 0,
      historyPage: 1,
      historyLimit: 20,
      historyTotalPages: 1,
      historyLoading: false
    }
  },

  computed: {
    organizationId(): string {
      return this.$store.getters['auth/user']?.organizationId || ''
    },

    productId(): string {
      return this.$store.getters['product/getCurrentProduct']?.id || ''
    },

    reports() {
      return [
        {
          tab: 'disbursements',
          title: 'Décaissements des SFD sur une période donnée',
          type: 'sfd_disbursement',
          filename: 'rapport_ligne_credit_sfd.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title:
            'Décaissements par département et commune sur une période donnée',
          type: 'state_and_common_disbursement',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title: "Décaissements par secteur d'activités sur une période donnée",
          type: 'activity_sector_disbursement',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title: 'Mise en place des crédits pour les bénéficiaires',
          type: 'beneficiary_dispatching',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'choice',
              name: 'otm',
              label: 'OTM',
              items: [
                { text: 'Tous les OTM', value: '' },
                { text: 'MTN', value: 'mtn' },
                { text: 'MOOV', value: 'moov' }
              ]
            },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point des remboursements des SFD vers le FNM',
          type: 'credit_line_deadlines',
          filename: 'rapport_remboursements_sfd_to_fnm.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point des remboursements des groupes de bénéficiaires sur une période donnée',
          type: 'beneficiary_group_reimbursement',
          filename: 'rapport_remboursements_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },

            {
              type: 'choice',
              name: 'department',
              label: 'Département',
              class: 'capitalize',
              reset: ['common'],
              items: [
                { text: 'Tous les départements', value: '' },
                ...zones.map(d => ({ text: d.name, value: d.name }))
              ]
            },
            {
              type: 'choice',
              name: 'common',
              label: 'Commune',
              class: 'capitalize',
              items({ department }: { department: string }) {
                if (department) {
                  return [
                    { text: 'Toutes les communes', value: '' },
                    ...(
                      zones.find(d => d.name === department)?.communes || []
                    ).map(c => ({ text: c.name, value: c.name }))
                  ]
                }
                return [{ text: 'Toutes les communes', value: '' }]
              }
            },
            {
              type: 'choice',
              name: 'otm',
              label: 'OTM',
              items: [
                { text: 'Tous les OTM', value: '' },
                { text: 'MTN', value: 'mtn' },
                { text: 'MOOV', value: 'moov' }
              ]
            },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point de la balance âgée des remboursements des sfd vers le fnm',
          type: 'sfd_to_fnm_reimbursement_aged_balance',
          filename: 'rapport_impayes_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point de la balance âgée des remboursements des bénéficiaires vers les sfd',
          type: 'beneficiary_to_sfd_reimbursement_aged_balance',
          filename: 'rapport_remboursement_sfd.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point du tableau de bord',
          type: 'dashboard',
          filename: 'rapport_impayes_sfd.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point du suivi mensuel des remboursements',
          type: 'monthly_reimbursement',
          filename: 'rapport_impayes_sfd.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Reporting sur les impayés',
          type: 'unpaid',
          filename: 'rapport_impayes.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Reporting global',
          type: 'global',
          filename: 'rapport_global.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false
            }
          ]
        },
        {
          tab: 'global',
          title: 'Reporting global par groupe de bénéficiaire',
          type: 'global_by_beneficiary_group',
          filename: 'global_by_beneficiary_group.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'global',
          title: 'Reporting global par bénéficiare',
          type: 'global_by_beneficiary',
          filename: 'global_by_beneficiary.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        }
      ]
    },

    displayedReports(this: any) {
      return this.reports.filter((report: any) => report.tab === this.activeTab)
    }
  },

  created() {
    if (this.activeTab === 'history') {
      this.loadHistory(1)
    }
  },

  watch: {
    activeTab(val: string) {
      if (val === 'history') {
        this.loadHistory(1)
      }
    }
  },

  methods: {
    formatDate(value: string | Date): string {
      if (!value) return '-'
      return moment(value).format('DD/MM/YYYY HH:mm')
    },

    loadHistory(page: number) {
      this.historyLoading = true
      const orgId = this.organizationId || undefined
      fetchReportList(page, this.historyLimit, orgId)
        .then((data) => {
          this.historyItems = data.items
          this.historyTotal = data.total
          this.historyPage = data.page
          this.historyTotalPages = data.totalPages
        })
        .catch((err) => { console.error('Failed to load history:', err) })
        .finally(() => { this.historyLoading = false })
    },

    downloadHistoryReport(item: any) {
      window.open(getReportDownloadUrl(item.id), '_blank')
    },

    deleteHistoryReport(item: any) {
      if (!confirm('Supprimer définitivement le rapport "' + item.title + '" ?')) return
      deleteReport(item.id).then(() => this.loadHistory(this.historyPage)).catch((err) => console.error(err))
    },

    statusClass(state: string): string {
      switch (state) {
        case 'completed': return 'bg-green-100 text-green-300'
        case 'running': return 'bg-orange-100 text-orange-300'
        case 'failed': return 'bg-red-100 text-red-300'
        default: return 'bg-gray-100 text-gray-700'
      }
    },

    stateLabel(state: string): string {
      switch (state) {
        case 'created': return 'Créé'
        case 'running': return 'En cours'
        case 'completed': return 'Terminé'
        case 'failed': return 'Échec'
        default: return state
      }
    },

    onGenerateReportClicked(
      this: any,
      options: Record<string, unknown>,
      report: any,
      index: number
    ) {
      Object.keys(options).forEach(key => {
        if (options[key] instanceof Date) {
          options[key] = moment(options[key] as Date).format('YYYY-MM-DD')
        }
      })

      const { dateFrom, dateTo, ...filters } = options

      this.$set(this.reportLoaders[this.activeTab], index, true)

      api
        .makeRequest({
          method: 'POST',
          url: 'reports',
          data: {
            type: report.type,
            title: report.title,
            format: this.exportFormat,
            productId: this.productId,
            dateFrom,
            dateTo,
            organizationId: this.organizationId,
            sendMail: true,
            filters
          }
        })
        .then((response: ApiResponse) => {
          if (!response.isSuccessful) {
            this.$set(this.reportLoaders[this.activeTab], index, false)
            return
          }
          this.showSuccessAlert = true
          this.checkReportStatus(response.data, report.title, index)
        })
    },

    checkReportStatus(this: any, report: any, title: string, index: number) {
      api
        .makeRequest({
          method: 'GET',
          url: `/reports/${report.id}`
        })
        .then((response: ApiResponse) => {
          if (response.isSuccessful) {
            // if (!['completed', 'failed'].includes(response.data.state)) {
            //   return setTimeout(() => {
            //     this.checkReportStatus(report, title, index)
            //   }, 5000)
            // }

            if (response.data.state === 'completed') {
              api
                .download(
                  `/reports/${report.id}/download`,
                  {},
                  title.toUpperCase().replace(/ /g, '_') +
                    '_DU_' +
                    moment(report.dateFrom).format('DD_MM_YYYY') +
                    '_AU_' +
                    moment(report.dateTo).format('DD_MM_YYYY') +
                    '.' +
                    response.data.format
                )
                .then(() => {
                  this.$set(this.reportLoaders[this.activeTab], index, false)
                })
            }
          }
        })
    }
  }
})
